import React, { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import { faEnvelope } from "@fortawesome/free-solid-svg-icons";
import { faMapMarker } from "@fortawesome/free-solid-svg-icons";
import "./form-container.css";

function FormContainer() {
  const [numberEmptyError, setNumberEmptyError] = useState(false);
  const [messageEmptyError, setMessageEmptyError] = useState(false);

  const [formFlag, setFormFlag] = useState({
    flag1: false,
    flag2: false,
    flag3: false,
  });
  const mobileNumber = "+543513110502";
  const [disable, setDisable] = useState(false);

  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    mobileNumberClient: "",
    address: "",
    email: "",
    message: "",
  });

  const { firstName, lastName, mobileNumberClient, address, email, message } =
    formData;
  const { flag1, flag2, flag3 } = formFlag;

  const onChange = (e) => {
    e.preventDefault();
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
    // setFormFlag(!flag2)
    // *** AGREGAR ESTA LÍNEA ***
    console.log(`Input "${e.target.name}" cambió a:`, e.target.value);
  };

  useEffect(() => {
    console.log(formData);
    if (mobileNumber.length < 1) {
      setNumberEmptyError(true);
      setTimeout(() => setNumberEmptyError(false), 3000);
    } else if (message.length < 1) {
      setMessageEmptyError(true);
      setTimeout(() => setMessageEmptyError(false), 3000);
    } else {
      // TODO: Enter code here
      // Regex expression to remove all characters which are NOT alphanumeric
      let number = mobileNumber.replace(/[^\w\s]/gi, "").replace(/ /g, "");

      // Appending the phone number to the URL

      let url = `https://wa.me/${number}?`;
      // Appending the message to the URL by encoding it
      url += `&text=${encodeURI(message)}&app_absent=0`;
      // Open our newly created URL in a new tab to send the message
      window.open(url);
      setDisable(false);
    }
  }, [flag1]);

  const toggle = () => {
    setFormFlag(!flag1);
    setDisable(true);
  };

  return (
    <section className="main-form">
      <div className="container-Form">
        <div className="info">
          <h1>¡Conversemos sobre tus necesidades! </h1>
          <h2>Informacion de Contacto</h2>
          <div className="info-text">
            {" "}
            <div className="item">
              <FontAwesomeIcon
                icon={faMapMarker}
                className="icon"
                style={{ color: "blue", fontSize: "24px" }}
              />
              <span>Dirk Kloosterman 1355 B SMATA Córdoba,Argentina</span>
            </div>
            <div className="item">
              {" "}
              <FontAwesomeIcon
                icon={faEnvelope}
                size="lg"
                className="icon"
                color="#17a2b8"
              />{" "}
              {/* <-- Aquí le das el color */}{" "}
              <span>sergiovaldivia@esigloxxiservicio.com</span>
            </div>
            <div className="item">
              {" "}
              <FontAwesomeIcon
                icon={faWhatsapp}
                size="lg"
                className="icon"
                color="#25D366"
              />{" "}
              {/* <-- Aquí le das el color directamente */}{" "}
              <span>+54 351 3110502</span>
            </div>
          </div>
        </div>

        <form className="form">
          <h2>Comunicate con nosotros</h2>
          <ul>
            <li>
              <div className="input-box w50">
                <input
                  type="text"
                  id="firstName"
                  name="firstName"
                  value={firstName}
                  required
                  onChange={onChange}
                />
                <span> Nombre </span>
              </div>
            </li>
            <li>
              <div className="input-box w50">
                <input
                  type="text"
                  id="lastName"
                  name="lastName"
                  value={lastName}
                  required
                  onChange={onChange}
                />
                <span> Apellido</span>
              </div>
            </li>
            <li>
              <div className="input-box w50">
                <input
                  type="email"
                  id="mail"
                  name="email"
                  value={email}
                  required
                  onChange={onChange}
                />
                <span> E-mail</span>
              </div>
            </li>
            <li>
              <div className="input-box w50">
                <input
                  type="text"
                  id="address"
                  name="address"
                  value={address}
                  required
                  onChange={onChange}
                />
                <span> Direccion </span>
              </div>
            </li>
            <li>
              <div className="input-box w50">
                <input
                  type="text"
                  id="mobileNumberClient"
                  name="mobileNumberClient"
                  value={mobileNumberClient}
                  required
                  onChange={onChange}
                />
                <span> Telefono </span>
              </div>
            </li>
            <li>
              <div className="input-box w100">
                <textarea
                  id="msg"
                  name="message"
                  value={message}
                  required
                  onChange={onChange}
                ></textarea>
                <span> Mensaje</span>
              </div>
            </li>

            <li>
              <div className="input-box w100">
                <button
                  type="submit"
                  className="button"
                  disabled={disable}
                  onClick={toggle}
                >
                  Enviar
                </button>
              </div>
            </li>
          </ul>
        </form>
      </div>
    </section>
  );
}

export default FormContainer;
